import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import nl2br from 'react-nl2br';

import { getTaskProperties } from '../../models/Task.js';
import {
  fetchTask,
  saveTask,
  setTask,
  commentTask,
} from '../../store/modules/task';
import { Comment } from '../Comment/Comment';
import mergeStates from '../../helpers/mergeStates';

import classes from './TaskDialog.scss';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import PeoplePicker from '../PeoplePicker/PeoplePicker';
import SplitButton from '../SplitButton/SplitButton';
import OvalIcon from '../../assets/ic_oval.svg';
import ContactCard from '../ContactCard/ContactCard';
import urlFromType from '../../helpers/urlFromType';
import localizedType from '../../helpers/localizedType';
import _ from 'lodash';
import InlineSVG from 'svg-inline-react';
import FileList from '../FileList/FileList';
import FormFileUpload from '../FormFileUpload/FormFileUpload';

const mapActionCreators: { fetchTask: Function, saveCurrentTask: Function } = {
  fetchTask,
  saveTask,
  setTask,
  commentTask,
};

const mapStateToProps = state => {
  const task =
    typeof state.task.tasks[state.task.current] !== 'undefined' &&
    state.task.tasks[state.task.current].title.length
      ? state.task.tasks[state.task.current]
      : null;

  const data = {
    task,
    fetching: state.task.fetching,
    current: state.task.current,
    assignee: null,
    creator: null,
    finisher: null,
    files: null,
  };

  if (task !== null) {
    data.assignee =
      task.assignee_id !== null
        ? { ...state.staff.staffs[task.assignee_id] }
        : null;
    data.creator =
      task.creator_id !== null
        ? { ...state.staff.staffs[task.creator_id] }
        : null;
    data.finisher =
      task.done_by !== null ? { ...state.staff.staffs[task.done_by] } : null;

    data.files = _.filter(_.pick(state.file.files, task.files), [
      'deleted_at',
      null,
    ]);
  }

  return data;
};

class TaskDialog extends React.Component {
  constructor(props) {
    super(props);

    this.receivedProps = false;

    this.state = {
      files: [],
      ...props.task,
      newComment: '',
      editing: false,
    };

    if (this.state.notes === null) {
      this.state.notes = '';
    }

    if (props.files !== null) {
      this.state.files = this.props.files;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.task !== 'undefined' &&
      nextProps.task !== null &&
      this.receivedProps === false
    ) {
      this.setTask(nextProps.task, nextProps.files);

      this.receivedProps = true;
    }

    if (typeof nextProps.task === 'undefined') {
      this.receivedProps = false;
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (
      JSON.stringify(_.omit(nextProps, ['saveTask', 'commentTask'])) !==
      JSON.stringify(_.omit(this.props, ['saveTask', 'commentTask']))
    ) {
      return true;
    }

    return false;
  }

  setTask = (task, files = null) => {
    this.setState({
      ...task,
      notes: task.notes === null ? '' : task.notes,
    });

    if (files !== null) {
      this.setState({
        files,
      });
    } else {
      if (this.props.files !== null) {
        this.setState({
          files: this.props.files,
        });
      }
    }
  };

  save = () => {
    // console.log('saving the comment', this.state.newComment);

    this.props.commentTask(this.props.task.id, { body: this.state.newComment });

    this.setState({
      newComment: '',
    });
  };

  checkSubmit = event => {
    if (event.keyCode === 13) {
      this.save();
    }
  };

  handleChange = (e, oldState, name, value) => {
    const nextState = mergeStates(e, this.state, name, value);
    this.setState(nextState);
  };

  renderCreator = () => {
    let creator = null;

    if (this.props.creator !== null) {
      if (this.state.editing) {
        creator = (
          <PeoplePicker
            name="creator_id"
            clearable={false}
            value={this.state.creator_id}
            default={this.props.creator.id}
            onChange={e => this.handleChange(e)}
          />
        );
      } else {
        creator = (
          <ContactCard
            displayType="link"
            avatar={this.props.creator.avatar}
            name={this.props.creator.name}
            type="staff"
            id={this.props.creator.id}
          />
        );
      }
    }

    return creator;
  };

  renderAssignee = () => {
    let assignee = null;

    if (
      typeof this.props.assignee !== 'undefined' &&
      this.props.assignee !== null
    ) {
      if (this.state.editing) {
        assignee = (
          <PeoplePicker
            name="assignee_id"
            clearable={false}
            value={this.state.assignee_id}
            default={this.props.assignee.id}
            onChange={e => this.handleChange(e)}
          />
        );
      } else {
        assignee = (
          <ContactCard
            displayType="link"
            avatar={this.props.assignee.avatar}
            name={this.props.assignee.name}
            type="staff"
            id={this.props.assignee.id}
          />
        );
      }
    }

    return assignee;
  };

  renderFinished = () => {
    if (this.props.task.is_done && this.props.finisher !== null) {
      return (
        <div className="col-xs-12 col-sm-6">
          <label className={classes.label}>Erledigt durch</label>
          <ContactCard
            displayType="link"
            avatar={this.props.finisher.avatar}
            name={this.props.finisher.name}
            type="staff"
            id={this.props.finisher.id}
          />
        </div>
      );
    }
    return null;
  };

  renderTitle = () => {
    let title = this.props.task.title;

    if (this.state.editing) {
      title = (
        <input
          type="text"
          name="title"
          value={this.state.title}
          onChange={e => this.setState({ title: e.target.value })}
          className={classes.titleText}
        />
      );
    }

    return (
      <div className={classes.title}>
        <input
          type="checkbox"
          defaultChecked={this.props.task.is_done}
          onClick={() =>
            this.props.saveTask({
              ...this.props.task,
              is_done: !this.props.task.is_done,
            })
          }
        />
        <span className={classes.titleText}>{title}</span>
      </div>
    );
  };

  renderNotes = () => {
    let notes = <span>{nl2br(this.props.task.notes)}</span>;

    if (this.state.editing) {
      notes = (
        <textarea
          name="notes"
          rows="4"
          onChange={e => this.handleChange(e)}
          value={this.state.notes}
        />
      );
    }

    return notes;
  };

  renderComments = () => {
    let comments = [];
    if (
      typeof this.props.task.comments !== 'undefined' &&
      !this.state.editing
    ) {
      const sortedComments = _.sortBy(
        this.props.task.comments,
        comment => new Date(comment.created_at),
      );
      comments = sortedComments.map(comment => (
        <Comment comment={comment} key={`comment_${comment.id}`} />
      ));
    }
    if (!this.state.editing) {
      comments.push(
        <div key="task_new_comment">
          <input
            name="newComment"
            onChange={e => this.handleChange(e)}
            onKeyDown={e => this.checkSubmit(e)}
            value={this.state.newComment}
            placeholder="Kommentar hinzufügen"
            className={classes.newComment}
          />
        </div>,
      );
    }
    if (comments.length) {
      comments.unshift(<hr key={`comment_hr`} />);
    }

    return comments;
  };

  renderFiles = () => {
    if (this.state.editing) {
      return (
        <FormFileUpload
          files={this.state.files}
          onUpdate={files => {
            this.setState({ files });
          }}
        />
      );
    } else {
      if (typeof this.props.files !== 'undefined' && !this.state.editing) {
        const sortedFiles = _.sortBy(
          this.props.files,
          file => new Date(file.created_at),
        );

        if (sortedFiles.length === 0) {
          return null;
        }

        return <FileList files={sortedFiles} />;
      }
    }

    return null;
  };

  render() {
    const props = this.props;

    if (this.props.task === null) {
      return <div />;
    }

    const actions = [];

    if (this.state.editing) {
      actions.push(
        <FlatButton
          label="Abbrechen"
          key={`action_cancel`}
          onMouseDown={() => {
            this.setState({ editing: false });
            this.setTask(props.task);
          }}
        />,
      );

      actions.push(
        <FlatButton
          primary
          label="Speichern"
          key={`action_save`}
          onMouseDown={() => {
            this.props.saveTask(this.state);
            this.setState({ editing: false });
            this.receivedProps = false;
          }}
        />,
      );
    } else {
      actions.push(
        <FlatButton
          label="Bearbeiten"
          key={`action_edit`}
          onMouseDown={() => this.setState({ editing: !this.state.editing })}
        />,
      );

      actions.push(
        <FlatButton
          label="Schließen"
          primary
          key={`action_close`}
          onMouseDown={() => {
            props.setTask(null);
            this.receivedProps = false;
          }}
        />,
      );
    }
    if (typeof props.task === 'undefined') {
      return (
        <Dialog
          title=""
          actions={actions}
          modal
          open={false}
          onRequestClose={() => props.setTask(null)}
        />
      );
    }
    const extraInfo = getTaskProperties(props.task);
    // console.log(extraInfo);
    let date = null;
    if (!this.state.editing) {
      if (extraInfo.dueDay !== null) {
        date = (
          <div className="col-xs-12 col-sm-6">
            <label className={classes.label}>Zu erledigen bis</label>
            <span>{extraInfo.dueDay}</span>
          </div>
        );
      }
    } else {
      date = (
        <div className="col-xs-12 col-sm-6">
          <label className={classes.label}>Zu erledigen bis</label>
          <SimplDatepicker
            defaultValue={this.state.due_date}
            dateFormatSubmit="YYYY-MM-DD HH:mm:ss"
            onChange={date => {
              this.handleChange(null, null, 'due_date', date);
            }}
          />
        </div>
      );
    }
    let dateFinished = null;
    if (extraInfo.doneDay !== null) {
      if (!this.state.editing) {
        dateFinished = (
          <div className="col-xs-12 col-sm-6">
            <label className={classes.label}>Erledigt am</label>
            <span>
              {extraInfo.doneDay} - {extraInfo.doneDate}
            </span>
          </div>
        );
      }
    }
    let note = null;
    if (
      this.state.editing ||
      (typeof props.task.notes !== 'undefined' &&
        props.task.notes !== null &&
        props.task.notes.length)
    ) {
      note = (
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <label className={classes.label}>Notiz</label>
            {this.renderNotes()}
          </div>
        </div>
      );
    }
    let connected = null;
    if (props.task.connected.name !== null && !this.state.editing) {
      connected = (
        <div className="col-xs-12 col-sm-6">
          <label className={classes.label}>Verknüpft mit</label>
          <Link
            to={urlFromType(props.task.taskable_type, props.task.taskable_id)}
          >
            {props.task.connected.name} (
            {localizedType(props.task.taskable_type)})
          </Link>
        </div>
      );
    }

    let priority = props.task.priority ? (
      <span>
        <InlineSVG src={OvalIcon} className={classes.inlineOval} />
        Wichtig
      </span>
    ) : (
      'Normal'
    );
    if (this.state.editing) {
      priority = (
        <div>
          <SplitButton
            selected={this.state.priority}
            onSelect={priority =>
              this.handleChange(null, null, 'priority', priority)
            }
            buttons={[
              {
                title: 'Normal',
                value: 0,
              },
              {
                title: 'Wichtig',
                value: 1,
                img: OvalIcon,
              },
            ]}
          />
        </div>
      );
    }
    priority = (
      <div className="col-xs-12 col-sm-6">
        <label className={classes.label}>Priorität</label>
        {priority}
      </div>
    );
    const dialogStyle = {
      width: '100%',
      maxWidth: '500px',
    };
    return (
      <Dialog
        title={this.renderTitle()}
        actions={actions}
        modal
        open={props.current.length > 0}
        contentStyle={dialogStyle}
        autoScrollBodyContent
        onRequestClose={() => props.setTask(null)}
        className="form modal-center"
        contentClassName="form-container form-container--task"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <label className={classes.label}>Zuständiger</label>
            {this.renderAssignee()}
          </div>
          <div className="col-xs-12 col-sm-6">
            <label className={classes.label}>Erstellt von</label>
            {this.renderCreator()}
          </div>
          {date}
          {dateFinished}
          {priority}
          {this.renderFinished()}
        </div>
        <div className="row">{connected}</div>
        {note}
        {this.renderFiles()}
        {this.renderComments()}
        <div className="firefoxSpacer" />
      </Dialog>
    );
  }
}
TaskDialog.propTypes = {
  commentTask: PropTypes.func.isRequired,
  saveTask: PropTypes.func,
  task: PropTypes.object,
  creator: PropTypes.object,
  assignee: PropTypes.object,
  finisher: PropTypes.object,
};
export default connect(mapStateToProps, mapActionCreators)(TaskDialog);



// WEBPACK FOOTER //
// ./src/components/TaskDialog/TaskDialog.js